import * as React from "react";
import { IconProps } from "../types";

const Flag3FillIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
        ref={forwardedRef}
        {...props}
    >
  <path d="M12.738,6.75l2.582-3.012c.191-.223,.234-.536,.112-.802-.122-.266-.388-.437-.681-.437H4V11H14.75c.293,0,.559-.17,.681-.437,.123-.266,.079-.579-.112-.802l-2.582-3.012Z" fill={color}></path>
  <path d="M3.75,17c-.414,0-.75-.336-.75-.75V1.75c0-.414,.336-.75,.75-.75s.75,.336,.75,.75v14.5c0,.414-.336,.75-.75,.75Z" fill={color}></path>
</svg>
    );
  },
);

export default Flag3FillIcon;
